import React, { useEffect } from 'react';
// import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
// import Dragger from 'draggerjs';
// import { css, addClass, removeClass } from 'Common/Utils';
import { ScrollNav } from './ScrollNav';
const SidePanelProps = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
};

export const SidePanel = ({ children }) => {
	// useEffect(() => {
	// 	let dragger,
	// 	cleanUp,
	// 	isComplete = false,
	// 	isSideWays = false,
	// 	isMove = false;
	// 	const media = window.matchMedia('(max-width: 769px)');
	// 	const handleMedia = () => { 
	// 		if (media.matches) { 
	// 			const sidebar = document.querySelector('.side-panel');
	// 			const backdrop = document.querySelector('#side-panel-backdrop'); 
	// 			const bunch = [sidebar, backdrop]; 
	// 			dragger = new Dragger(sidebar, {
	// 				allowBoundContainer: false,
	// 			});
	// 			dragger.on('dragstart', (e) => { 
	// 				if (e.target.matches('input, label')) return
	// 				if (!e.target.matches('.side-panel a')) e.preventDefault(); 
	// 				css(sidebar, 'right', `${isComplete ? 0 : -sidebar.clientWidth}px`);
	// 				bunch.forEach((el) => {
	// 					addClass(el, 'grabbed');
	// 					removeClass(el, 'transition');
	// 				});
	// 				clearTimeout(cleanUp);
	// 			});
	// 			dragger.on('dragmove', (e) => { 
	// 				if (!isMove) {
	// 					isSideWays =
	// 						(e.moveX > e.startX ? e.moveX - e.startX : e.startX - e.moveX) >
	// 							(e.moveY > e.startY
	// 								? e.moveY - e.startY
	// 								: e.startY - e.moveY) || !isComplete;
	// 					isMove = true;
	// 				}
	// 				if (!isSideWays || e.target.matches('.side-panel input')) return;
	// 				const width = sidebar.clientWidth;
	// 				const distance = isComplete
	// 					? e.startX - e.moveX
	// 					: e.startX - e.moveX - width;
	// 				css(
	// 					backdrop,
	// 					'opacity',
	// 					(width - Math.min(width, Math.abs(Math.min(0, distance)))) /
	// 						(width * 1.3)
	// 				);
	// 				css(
	// 					sidebar,
	// 					'right',
	// 					`${0 > distance ? (-width > distance ? -width : distance) : 0}px`
	// 				);
	// 			});
	// 			dragger.on('dragend', (e) => { 
	// 				isMove = false;
	// 				setTimeout(
	// 					() =>
	// 						bunch.forEach((el) => {
	// 							removeClass(el, 'grabbed');
	// 						}),
	// 					0
	// 				);
	// 				if (!isSideWays || e.target.matches('.side-panel input')) return;
	// 				const width = sidebar.clientWidth;
	// 				const distance = isComplete
	// 					? e.startX - e.endX + width
	// 					: e.startX - e.endX;
	// 				if (distance > sidebar.clientWidth / (isComplete ? 1.2 : 2)) {
	// 					bunch.forEach((el) => {
	// 						addClass(el, 'show');
	// 					});
	// 					isComplete = true;
	// 				} else {
	// 					bunch.forEach((el) => {
	// 						removeClass(el, 'show');
	// 					});
	// 					isComplete = false;
	// 				}
	// 				/*didn't do bunch here because it is not transitioning in mobile chrome*/
	// 				addClass(backdrop, 'transition');
	// 				addClass(sidebar, 'transition');
	// 				css(sidebar, 'right', null);
	// 				css(backdrop, 'opacity', null);
	// 				cleanUp = setTimeout(() => {
	// 					removeClass(sidebar, 'transition');
	// 				}, 300);
	// 			});
	// 		} else { 
	// 			dragger && dragger.destroy();
	// 		}
	// 	};
	// 	handleMedia();
	// 	media.addListener(handleMedia);
	// 	return () => {
	// 		media.removeListener(handleMedia);
	// 		dragger && dragger.destroy();
	// 	};
	// }, []);
	return (
		<>
			<nav className='side-panel'>
				{children}
				{/* <div className='mobile-tip' /> */}
			</nav>
			{/* {ReactDOM.createPortal(
				<div className='mobile-backdrop' id='side-panel-backdrop' />,
				document.body
			)} */}
		</>
	);
};

SidePanel.propTypes = SidePanelProps;

SidePanel.ScrollNav = ScrollNav;
